import { prefersReducedMotion } from './motion';

/** Short vibration on phones that support it (rejected scan, finished step); patterns live in constants/haptics. */
export function buzz(pattern: number | readonly number[]) {
  try {
    if (!prefersReducedMotion() && 'vibrate' in navigator) navigator.vibrate(typeof pattern === 'number' ? pattern : [...pattern]);
  } catch {
    /* not supported */
  }
}
